import React, {useEffect, useState} from "react";
import {
    Typography,
    Grid,
    makeStyles,
    Container,
    Card,
    Button, Box, useMediaQuery
} from "@material-ui/core";
import {colorGrayText} from "../../Constants/theme";
import {api_getPartnerGifts, setApiOwnerEmailGift} from "../../redux/user/user.api";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../redux/store";
import {Gift} from "../../Components";
import {useTheme} from "@material-ui/core/styles";
import {useHistory} from "react-router-dom";
import {setFunnelEmailGiftId} from "../../redux/scheduleAppointment/scheduling.reducers";
import {updateIsGiftReceived, updatePromotionCode} from "../../redux/scheduleAppointment/scheduling.actions";

const useStyle = makeStyles(() => ({
    cardRoot: {
        width: "100%",
        padding: 40,
        marginBottom: 32,
    },
    containerRoot: {
        paddingTop: 100,
        marginBottom: 55,
        zIndex: 1,
    },
    body: {
        paddingTop: 20,
    },
    spacing: {
        paddingTop: 20,
    },
    spacingImage: {
        paddingTop: 20,
        display: "flex"
    },
}));

const Gifts = () => {
    const classes = useStyle();
    const history = useHistory();
    const theme = useTheme();
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state?.user);
    const pet = useSelector((state: RootState) => state?.pets.selectedPet);
    const isGiftReceived = useSelector((state: RootState) => state?.scheduleAppointment.isGiftReceived);
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [gifts, setGifts] = useState([]);
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        if (!isGiftReceived) {
            dispatch(updateIsGiftReceived(true));
        }
    }, []);
    useEffect(() => {
        api_getPartnerGifts(pet.type, user.userId)
            .then((res) => {
                setGifts(res);
            })
            .catch(err=>{
                history.push("/schedule");
            });
    }, []);

    useEffect(() => {
        if (gifts.length) {
            setSelected(gifts[0].id);
        }
    }, [gifts]);

    const saveGift = () => {
        dispatch(updateIsGiftReceived(false));
        if(!!selected){
            setApiOwnerEmailGift(selected)
                .then((res) => {
                    dispatch(setFunnelEmailGiftId(res.id));
                });
        }
        dispatch(updatePromotionCode("GIFT15"));
        history.push("/schedule");
    };

    return (
        <Container className={classes.containerRoot} maxWidth="md">
            <Card className={classes.cardRoot}>
                <Container className={classes.body} disableGutters={true}>
                    <Grid item container xs={12} alignItems="center" justify="center" spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h2" align="center" style={{fontSize: 42, paddingBottom: 25}}>
                                Select Your Gift!
                            </Typography>
                        </Grid>
                        <Grid item xs={11}>
                            <Box
                                display="flex"
                                justifyContent={isMobile || gifts.length === 1 ? "center" : "space-between"}
                                flexWrap="wrap"
                            >
                                {gifts.map((
                                    {
                                        companyDetails,
                                        giftDetails,
                                        id,
                                        imageUrl,
                                        name,
                                    }) => {
                                    const isSelected = selected === id;
                                    return (
                                        <Gift
                                            selected={isSelected}
                                            setSelected={() => setSelected(id)}
                                            giftDetails={giftDetails}
                                            companyDetails={companyDetails}
                                            imageUrl={imageUrl}
                                            name={name}
                                        />
                                    );
                                }
                                )}
                            </Box>
                        </Grid>
                        <Grid item xs={11}>
                            <Button
                                type="button"
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={saveGift}
                            >
                                Save and Next
                            </Button>
                        </Grid>
                        <Grid container justify="flex-end">
                            <Button
                                type="button"
                                variant="text"
                                style={{color: colorGrayText, textDecoration: "underline", fontWeight: 700}}
                                onClick={()=>{
                                    setSelected(null);
                                    history.push("/schedule");
                                }}
                            >
                                I don't want a gift
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography style={{color: colorGrayText, fontWeight: 700}} variant="h6">
                                Gift Redemption
                            </Typography>
                            <Typography style={{color: colorGrayText}}>
                                You will receive instructions on redemption in your email inbox.
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>
            </Card>
        </Container>
    );
};

export default Gifts;
